import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { ChipProps } from "@/types";
import { Typography } from "../content";


/**
 * Displays a generic chip.
 */
const __default__ = {
  name: "Chip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    dense: { type: Boolean },
    class: {},
    color: {},
    style: {},
    outlined: { type: Boolean },
    clickable: { type: Boolean },
    removable: { type: Boolean },
    dataCy: {}
  },
  emits: ["click", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const chipColor = computed(() => {
  if (props.color?.includes("#")) {
    return "";
  } else if (props.color) {
    return props.color;
  } else {
    return "";
  }
});

const chipStyle = computed(() => {
  if (props.style) {
    return props.style;
  } else if (props.color?.includes("#")) {
    return `color: ${props.color}; border-color: ${props.color} !important`;
  } else {
    return "";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(_component_q_chip, {
    class: _normalizeClass(props.class),
    outline: props.outlined,
    color: chipColor.value,
    "data-cy": props.dataCy,
    style: _normalizeStyle(chipStyle.value),
    clickable: props.clickable,
    removable: _ctx.removable,
    dense: props.dense,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onRemove: _cache[1] || (_cache[1] = ($event: any) => (emit('remove')))
  }, {
    default: _withCtx(() => [
      (!!props.label)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 0,
            value: props.label
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "outline", "color", "data-cy", "style", "clickable", "removable", "dense"]))
}
}

})